export default "__VITE_ASSET__b706aa29__"